


































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import AccountModule from '@/store/modules/Account';
import DashboardModule from '@/store/modules/Dashboard';
import AgentBannerModule from '@/store/modules/AgentBanner';
import DownlineChart from '@/components/Chart/Downline.vue';
import BalanceChart from '@/components/Chart/Balance.vue';
import NewDownlineChart from '@/components/Chart/NewDownline.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwtDecode from 'jwt-decode';
import mafiaWays2 from '@/assets/images/banner/mafiaWays2.png';
import guardianWealth from '@/assets/images/banner/guardianWealth.png';
import goldenBlackJack from '@/assets/images/banner/goldenBlackJack.png';
import tiki from '@/assets/images/banner/tiki.jpeg';
import clashOfWar from '@/assets/images/banner/clashOfWar.png';
import subwayRunner from '@/assets/images/banner/subwayRunner.png';
import wizardDice from '@/assets/images/banner/wizardDice.png';
import naturalAce from '@/assets/images/banner/naturalAce.jpeg';
import superAceX from '@/assets/images/banner/superAceX.jpeg';
import mahjongLegacy from '@/assets/images/banner/mahjongLegacy.jpeg';
import aztecLegend from '@/assets/images/banner/aztecLegend.jpeg';
import nekoReborn from '@/assets/images/banner/nekoReborn.jpg';
import aztecEmpire from '@/assets/images/banner/aztecEmpire.jpg';

@Component({
  components: {
    DownlineChart,
    BalanceChart,
    NewDownlineChart,
  },
})
export default class DashboardView extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  AccountInstance = getModule(AccountModule, this.$store);

  DashboardInstance = getModule(DashboardModule, this.$store);

  AgentBannerInstance = getModule(AgentBannerModule, this.$store);

  pageOption = {
    page: 1,
    limit: 1,
  };

  totalTurnoverSeries: any = [];

  totalWinloseSeries: any = [];

  turnoverSeries: any = [];

  winloseSeries: any = [];

  stakeSeries: any = [];

  newDownlineSeries: any = [];

  activeUserSeries: any = [];

  depositWithdrawSeries: any = [];

  refillDeductSeries: any = [];

  compDownlineKey = 0;

  compBalanceKey = 0;

  compNewDownlineKey = 0;

  compActiveUserKey = 0;

  compDepositWithdrawKey = 0;

  compRefillDeductKey = 0;

  items = [
    {
      img: true,
      src: nekoReborn,
    },
    {
      img: true,
      src: aztecEmpire,
    },
    {
      img: true,
      src: mahjongLegacy,
    },
    {
      img: true,
      src: aztecLegend,
    },
    {
      img: true,
      src: superAceX,
    },
    {
      img: true,
      src: naturalAce,
    },
    {
      img: true,
      src: clashOfWar,
    },
    {
      img: true,
      src: tiki,
    },
    {
      img: true,
      src: mafiaWays2,
    },
    {
      img: true,
      src: goldenBlackJack,
    },
    {
      img: true,
      src: guardianWealth,
    },
    {
      img: true,
      src: wizardDice,
    },
    {
      img: true,
      src: subwayRunner,
    },
  ];

  todayTurnover = 0;

  yesterdayTurnover = 0;

  todayWinlose = 0;

  yesterdayWinlose = 0;

  userCurrency = {};

  userWallet = 0;

  totalTurnover: any = []

  totalWinlose: any = []

  agentCount = 0;

  memberCount = 0;

  @Watch('$i18n.locale')
  onLanguagChange() {
    this.compDownlineKey += 1;
    this.compBalanceKey += 1;
    this.compNewDownlineKey += 1;
    this.compActiveUserKey += 1;
    this.compDepositWithdrawKey += 1;
    this.compRefillDeductKey += 1;
  }

  async created() {
    const { pageOption } = this;
    const {
      username, source, role, wallet,
    } = this.AuthInstance.user;
    this.userWallet = wallet.balance;
    this.userCurrency = jwtDecode(this.AuthInstance.token);
    const resDownline = await this.AccountInstance.FetchDownLine({
      pageOption,
      username,
      source,
      isDashboard: true,
    });
    if (resDownline.code) {
      this.checkError(resDownline);
    }
    await this.AgentBannerInstance.FetchAgentBanner({ isActive: true });
    const res = await this.DashboardInstance.FetchDashboard({ username, source, role });
    for (let index = 0; index < Object.keys(res.report).length; index += 1) {
      const element = res.report[Object.keys(res.report)[index]];
      const value = element.find((v) => v.key === this.userCurrency.currency || 'THB');
      this.turnoverSeries = [...this.turnoverSeries, value ? value.turnover.value : 0];
      this.winloseSeries = [...this.winloseSeries, value ? value.winlose.value * -1 : 0];
      this.stakeSeries = [...this.stakeSeries, value ? value.stake.value : 0];
    }
    for (let index = 0; index < res.sumCurrency.length; index += 1) {
      const element = res.sumCurrency[index];
      this.totalTurnover.push({
        name: element.key,
        y: element.turnoverUsdt,
        amountCurrency: element.turnover.value,
      });
      this.totalWinlose.push({
        name: element.key,
        y: element.winloseUsdt * -1,
        amountCurrency: element.winlose.value * -1,
      });
    }
    this.memberCount = res.member;
    this.agentCount = res.agent;
    this.turnoverSeries = [
      {
        name: 'Turnover',
        data: this.turnoverSeries,
        color: '#87cefa',
      },
    ];
    this.winloseSeries = [
      {
        name: 'Winlose',
        data: this.winloseSeries,
        color: '#66cdaa',
      },
    ];
    this.stakeSeries = [
      {
        name: 'Stake',
        data: this.stakeSeries,
        color: '#ffbe98',
      },
    ];
    this.totalTurnoverSeries = [
      {
        name: 'Downline',
        data: this.totalTurnover,
      },
    ];
    this.totalWinloseSeries = [
      {
        name: 'Downline',
        data: this.totalWinlose,
      },
    ];
    this.compDownlineKey += 1;
    this.compBalanceKey += 1;
    this.compNewDownlineKey += 1;
    this.compActiveUserKey += 1;
    this.compDepositWithdrawKey += 1;
    this.compRefillDeductKey += 1;
  }
}
